import { ALL_COMPANIES_OPTION } from 'utils/partnerUtils'

import {
  selectActualFeatureFlags,
  selectDefaultIncidentDateFilter,
  selectSelfFeatureFlags,
} from 'containers/App/selectors'
import { selectCompanyFilter } from 'containers/PartnerOptions/selectors'

import { ALL_TIMES, INCIDENT_DATE_FILTERS_OPTIONS, LAST_24_HOURS } from './constants'

export const selectRegularFilters = (state) => state.resolutioncenter.incidentFilters.regularFilters

export const selectAssigneesOptions = (state) =>
  state.resolutioncenter.incidentFilters.assignees.slice(0, 5)

export const selectIsRegularFilterActive = (state) =>
  !!Object.keys(state.resolutioncenter.incidentFilters.regularFilters).filter(
    (key) => state.resolutioncenter.incidentFilters.regularFilters[key]?.length
  ).length

/**
 * Today's filters for IM Service Company are:
 *   Bubble Ups
 *   Auto Themis (below TH)
 */
const selectShowFilterToIMServiceCompany = (state) => (filterSelector) =>
  selectSelfFeatureFlags(state).IM_SERVICE_COMPANY &&
  (filterSelector(state) || selectCompanyFilter(state)?.value === ALL_COMPANIES_OPTION.value)

const selectActualPotentialReportsFilter = (state) =>
  selectActualFeatureFlags(state).ENABLE_POTENTIAL_REPORTS ||
  selectActualFeatureFlags(state).ENABLE_POTENTIAL_REPORTS_V2

const selectActualAutoThemisFilter = (state) => selectActualFeatureFlags(state).ENABLE_AUTO_THEMIS

export const selectAllowSeeingPotentialIncidents = (state) =>
  selectShowFilterToIMServiceCompany(state)(selectActualPotentialReportsFilter)

export const selectAllowSeeingAutoThemis = (state) =>
  selectShowFilterToIMServiceCompany(state)(selectActualAutoThemisFilter)

export const selectDateFiltersOptions = (state) => {
  const ff = selectActualFeatureFlags(state)
  if (ff.POV_COSTUMER_FF) {
    return INCIDENT_DATE_FILTERS_OPTIONS.filter((option) => option.value !== ALL_TIMES)
  }
  return INCIDENT_DATE_FILTERS_OPTIONS
}

export const selectDefaultIncidentDateFilterWithDefault = (state) =>
  selectDefaultIncidentDateFilter(state) || LAST_24_HOURS
